// extracted by mini-css-extract-plugin
export var checkoutHoverCard = "_my-2";
export var interactiveWrapper = "_my-0";
export var shippingHoverPreview = "_my-4";
export var summaryBadgeTrigger = "_my-1";
export var widgetHoverPreviewList = "_my-3";
export var widgetPreviewScale = "_my-5";